import { render, staticRenderFns } from "./GangGuTong.vue?vue&type=template&id=48233f94&scoped=true"
import script from "./GangGuTong.vue?vue&type=script&lang=js"
export * from "./GangGuTong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48233f94",
  null
  
)

export default component.exports